export default __webpack_public_path__ + "static/media/mobile1.60953814.webp";